import React from 'react';
import { WhiteLabelLandingTemplate, CountryConfig } from './WhiteLabelLandingTemplate';

const canadaConfig: CountryConfig = {
  country: 'Canada',
  currencySymbol: 'CA$',
  prices: {
    basic:   'CA$3,400',
    prime:   'CA$6,800',
    elite:   'CA$10,200',
    supreme: 'CA$13,600'
  },
  costComparison: [
    { role: 'Media Buyer',    cost: 'CA$82k – CA$122k yearly' },
    { role: 'SEO Specialist', cost: 'CA$75k – CA$108k yearly' },
    { role: 'Designer',       cost: 'CA$68k – CA$95k yearly'  }
  ],
  timezoneQuestion: 'Do you support Canada timezone?',
  timezoneAnswer: 'Yes. Timezone alignment is available for agencies that require it.',
  agencyLabel: 'Canada Agency Partnership Lead',
  thankYouPath: '/whitelabelcanada/thank-you',
  phonePlaceholder: '+1 (604) 000-0000',
  cityPlaceholder: 'Toronto, ON',
  testimonials: [
    {
      quote: 'Their white-label execution has helped us scale client delivery without increasing payroll pressure.',
      author: 'Agency Owner, Toronto',
      result: 'Scaled from 22 to 48 active projects in 6 months'
    },
    {
      quote: 'Fast turnaround, transparent reporting, and strong campaign outcomes. Our clients are happier than ever.',
      author: 'Growth Director, Vancouver',
      result: 'Improved retention and reduced campaign delays by 40%'
    },
    {
      quote: 'They work exactly like an in-house team under our brand. Communication and quality are consistently strong.',
      author: 'Founder, Calgary',
      result: 'Increased margins while expanding service capacity'
    }
  ],
  docTitle: 'White Label Digital Marketing Execution for Canadian Agencies | Mirani Marketing',
  docDescription: 'Scale your digital marketing agency without hiring more staff. Dedicated execution team delivering SEO, AI-SEO, Google Ads, Meta Ads, Creative Production, and Video Editing under your agency brand — built for Canadian agencies.'
};

export const CanadaLandingPage: React.FC = () => <WhiteLabelLandingTemplate config={canadaConfig} />;
export default CanadaLandingPage;
